module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/en/1-cdaff9bae33ff47e4813db4e4dacf76c.jpg";